import axios from 'axios'
import customConstants from '../../Constants'

/**
 * Create a new role group via approval workflow
 * @param {Object} roleGroupData - Role group data
 * @param {string} roleGroupData.roleGroupName - Name of the role group
 * @param {Array<string>} roleGroupData.roleList - Array of role names
 * @param {string} roleGroupData.checkerUsername - Username of the checker
 * @returns {Promise} Axios response - Returns true on success
 */
export const createRoleGroup = (roleGroupData) => {
    return axios.post(
        `${customConstants.API_URL}/role-groups/`,
        {
            roleGroupName: roleGroupData.roleGroupName,
            roleList: roleGroupData.roleList,
            checkerUsername: roleGroupData.checkerUsername
        }
    )
}

/**
 * List all role groups
 * @returns {Promise} Axios response with role groups data
 * Response format (can be array directly or wrapped in roleGroups):
 * [
 *   {
 *     "roleGroup": {
 *       "orgId": "fdae66ea-f90e-455d-bded-40e0b2cc9401",
 *       "roleGroupId": "078ff655-d621-4530-918d-8fbaab0e1917",
 *       "roleGroupName": "kulla",
 *       "roleList": ["agent", "checker", "maker"],
 *       "createdAt": "2025-12-10T09:18:04Z",
 *       "createdBy": "bora.erbasoglu@gmail.com",
 *       "status": "ACTIVE"
 *     },
 *     "assignedUserCount": 0
 *   }
 * ]
 */
export const listAllRoleGroups = () => {
    return axios.get(`${customConstants.API_URL}/role-groups/list`)
}

/**
 * Update a role group via approval workflow
 * @param {Object} roleGroupData - Role group data
 * @param {string} roleGroupData.roleGroupId - ID of the role group to update
 * @param {string} roleGroupData.roleGroupName - Updated name of the role group
 * @param {Array<string>} roleGroupData.roleList - Updated array of role names
 * @param {string} roleGroupData.checkerUsername - Username of the checker
 * @returns {Promise} Axios response - Returns true on success
 */
export const updateRoleGroup = (roleGroupData) => {
    return axios.put(
        `${customConstants.API_URL}/role-groups/update`,
        {
            roleGroupId: roleGroupData.roleGroupId,
            roleGroupName: roleGroupData.roleGroupName,
            roleList: roleGroupData.roleList,
            checkerUsername: roleGroupData.checkerUsername
        }
    )
}

/**
 * Delete a role group via approval workflow
 * @param {Object} deleteData - Delete data
 * @param {string} deleteData.roleGroupId - ID of the role group to delete
 * @param {string} deleteData.checkerUsername - Username of the checker
 * @returns {Promise} Axios response - Returns true on success
 * Note: Cannot delete if users are assigned to this role group
 * Will return error: role_group_has_assigned_users with count
 */
export const deleteRoleGroup = (deleteData) => {
    return axios.delete(
        `${customConstants.API_URL}/role-groups/delete`,
        {
            data: {
                roleGroupId: deleteData.roleGroupId,
                checkerUsername: deleteData.checkerUsername
            }
        }
    )
}

